<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item" href="/">
        <img src="/company-logo.png">
      </a>
    <!-- <a href="/" class="navbar-item">
      <svg width="230" height="53" viewBox="0 0 230 53" fill="none" xmlns="http://www.w3.org/2000/svg" class="header__logo-svg"><path d="M26.883 52.77c14.846 0 26.882-11.813 26.882-26.385C53.765 11.813 41.729 0 26.882 0 12.037 0 0 11.813 0 26.385c0 14.573 12.036 26.386 26.883 26.386Z" fill="#F44B34"></path> <path d="M35.337 11.244c-1.324-1.35-3.16-2-5.5-2-7.181-.05-9.726-.05-10.388-.05l-2.237 5.298h6.362l-4.27 4.547v16.193l-.047.05.047.05v5.147l-2.848 3.047h14.517l6.405-6.798V16.691c-.004-.05.056-3.247-2.041-5.447Zm-4.125 15.141-5.806 5.997v-3.306l5.806-5.997v3.306Zm-5.806-11.893h2.344c.713 0 1.678-.05 2.442.7.764.75 1.072 1.948 1.072 3.796v2.75l-5.786 5.997-.073-13.243ZM21.587 37.78l2.596-2.75 7.028-7.346V37.78h-9.624Z" fill="#fff"></path> <path d="m81.736 9.93-5.115 5.02 3.27 3.209 5.114-5.02-3.27-3.21Zm11.653 21.476 3.27 3.21 5.111-5.02-3.266-3.21-5.115 5.02ZM90.891 7.359c.337-.33.736-.592 1.176-.77a3.682 3.682 0 0 1 3.948.77c.336.33.603.722.785 1.154a3.498 3.498 0 0 1 0 2.721 3.553 3.553 0 0 1-.785 1.154l-2.618 2.569 3.271 3.21 2.613-2.569a3.657 3.657 0 0 1 2.562-1.041c.961 0 1.883.374 2.562 1.041a3.524 3.524 0 0 1 1.061 2.515c0 .943-.382 1.847-1.061 2.514l-2.617 2.57 3.266 3.205 2.617-2.569a8.035 8.035 0 0 0 2.263-4.176 7.951 7.951 0 0 0-.505-4.704 8.128 8.128 0 0 0-3.101-3.622 8.35 8.35 0 0 0-4.634-1.298 7.982 7.982 0 0 0-1.326-4.548 8.204 8.204 0 0 0-3.69-3.042 8.384 8.384 0 0 0-4.793-.497 8.29 8.29 0 0 0-4.256 2.22l-2.617 2.569 3.27 3.206 2.61-2.582Zm-5.888 15.816 3.27 3.21 5.116-5.02-3.27-3.206-5.116 5.016Z" fill="#009AD9"></path> <path d="m76.621 37.822 5.115 5.02 3.267-3.206-5.115-5.02-3.267 3.206Zm28.419-11.437-3.27 3.21 2.617 2.57a3.52 3.52 0 0 1 1.061 2.514 3.52 3.52 0 0 1-1.061 2.514 3.657 3.657 0 0 1-2.562 1.042 3.657 3.657 0 0 1-2.562-1.042L96.65 34.63l-3.27 3.206 2.617 2.569a3.523 3.523 0 0 1 1.061 2.514c0 .943-.381 1.848-1.06 2.514a3.658 3.658 0 0 1-2.563 1.042c-.96 0-1.882-.375-2.562-1.041l-2.617-2.57-3.27 3.21 2.617 2.57a8.291 8.291 0 0 0 4.256 2.219 8.384 8.384 0 0 0 4.792-.497 8.206 8.206 0 0 0 3.691-3.042 7.981 7.981 0 0 0 1.325-4.547 8.358 8.358 0 0 0 4.634-1.302 8.123 8.123 0 0 0 3.099-3.622 7.944 7.944 0 0 0 .506-4.704 8.043 8.043 0 0 0-2.261-4.177l-2.605-2.586Zm-20.033 3.21 5.11 5.021 3.271-3.21-5.115-5.02-3.266 3.21ZM96.66 18.159l-3.271 3.206 5.115 5.02 3.266-3.206-5.11-5.02h-.005.004Z" fill="#6EBD44"></path> <path d="m90.11 34.599-5.114 5.02 3.267 3.206 5.114-5.02-3.266-3.206ZM79.119 45.42a3.658 3.658 0 0 1-2.562 1.041 3.66 3.66 0 0 1-2.562-1.041 3.523 3.523 0 0 1-1.061-2.515c0-.943.382-1.847 1.061-2.514l2.617-2.569-3.27-3.206-2.613 2.569a3.682 3.682 0 0 1-5.124 0 3.553 3.553 0 0 1-.785-1.154 3.5 3.5 0 0 1 .785-3.875l2.617-2.569-3.266-3.206-2.617 2.57a8.038 8.038 0 0 0-2.263 4.175 7.946 7.946 0 0 0 .505 4.705 8.124 8.124 0 0 0 3.101 3.62 8.352 8.352 0 0 0 4.634 1.3 7.974 7.974 0 0 0 1.323 4.548 8.2 8.2 0 0 0 3.69 3.043 8.38 8.38 0 0 0 4.793.496 8.287 8.287 0 0 0 4.255-2.22l2.617-2.565-3.266-3.21-2.61 2.577Zm2.617-19.035-5.115 5.02 3.267 3.207 5.115-5.017-3.267-3.21Zm-8.386-8.226-5.115 5.02 3.271 3.206 5.115-5.02-3.27-3.206Z" fill="#F68F1E"></path> <path d="m76.621 31.406-5.115-5.02-3.27 3.205 5.114 5.02 3.271-3.205ZM65.614 20.61a3.552 3.552 0 0 1-.785-1.153 3.5 3.5 0 0 1 0-2.722c.182-.431.449-.823.785-1.154a3.63 3.63 0 0 1 1.175-.77 3.683 3.683 0 0 1 2.773 0c.44.178.84.44 1.176.77l2.613 2.57 3.27-3.21-2.617-2.57a3.523 3.523 0 0 1-1.061-2.514c0-.943.382-1.848 1.061-2.515a3.658 3.658 0 0 1 2.562-1.041c.96 0 1.882.374 2.562 1.041l2.617 2.57 3.267-3.207-2.614-2.569a8.29 8.29 0 0 0-4.255-2.219 8.384 8.384 0 0 0-4.793.496 8.204 8.204 0 0 0-3.69 3.043 7.979 7.979 0 0 0-1.326 4.548 8.35 8.35 0 0 0-4.634 1.298 8.123 8.123 0 0 0-3.101 3.621 7.945 7.945 0 0 0-.505 4.704 8.038 8.038 0 0 0 2.262 4.177l2.618 2.569 3.266-3.206-2.626-2.557ZM88.276 9.94l-3.266 3.207 5.114 5.02 3.267-3.207-5.115-5.02Zm-6.54 16.445 3.267-3.21-5.115-5.016-3.267 3.206 5.115 5.02Z" fill="#EC174C"></path> <path d="M85.004 6.723 81.737 9.93l3.27 3.21 3.267-3.207-3.27-3.21Z" fill="#573357"></path> <path d="m68.253 23.206-3.27 3.209 3.27 3.21 3.27-3.21-3.27-3.21Z" fill="#BE272D"></path> <path d="m101.774 23.178-3.27 3.21 3.27 3.208 3.269-3.209-3.269-3.21Z" fill="#008E4C"></path> <path d="m84.993 39.608-3.27 3.21 3.267 3.206 3.27-3.21-3.267-3.206Z" fill="#7A773E"></path> <path d="m93.381 14.934-3.267 3.207 3.27 3.209 3.267-3.206-3.27-3.21Z" fill="#443639"></path> <path d="m76.62 31.4-3.27 3.209 3.27 3.21 3.27-3.21-3.27-3.21Z" fill="#803136"></path> <path d="m76.6 14.906-3.27 3.209 3.27 3.21 3.27-3.21-3.27-3.21Z" fill="#593438"></path> <path d="m85.007 23.177-3.27 3.21 3.27 3.209 3.27-3.21-3.27-3.21Z" fill="#443639"></path> <path d="m93.38 31.38-3.27 3.209 3.27 3.21 3.269-3.21-3.27-3.21Z" fill="#2A6442"></path> <path d="M204.732 28.9h-2.746v2.678h2.746V28.9Zm6.327.07h-2.861v14.874c0 1.844.551 3.18 1.631 3.973.961.704 2.464 1.073 4.466 1.106h.043v-2.36h-.043a4.432 4.432 0 0 1-2.134-.456c-.739-.465-1.111-1.337-1.111-2.59v-6.315h3.28v-2.335h-3.28l.009-5.896Zm-75.695 5.478a5.227 5.227 0 0 0-2.899.797 5.266 5.266 0 0 0-1.802 2.028c-.943-1.882-2.51-2.795-4.786-2.795a4.73 4.73 0 0 0-2.316.482 4.62 4.62 0 0 0-1.774 1.538V34.82h-2.746v14.161h2.746l.119-8.298a3.936 3.936 0 0 1 .888-2.732c.312-.336.697-.6 1.126-.77a3.15 3.15 0 0 1 1.355-.215 3.26 3.26 0 0 1 2.485 1.014c.65.751.979 1.72.918 2.703v8.24h2.716v-8.24a3.766 3.766 0 0 1 .917-2.703c.319-.34.709-.606 1.143-.781a3.265 3.265 0 0 1 1.372-.233c.46-.02.919.06 1.343.235a3.09 3.09 0 0 1 1.108.78c.624.763.94 1.725.888 2.702v8.24h2.746v-8.65c0-1.786-.508-3.215-1.507-4.258a5.326 5.326 0 0 0-1.849-1.207 5.411 5.411 0 0 0-2.191-.36Zm14.996 0a6.72 6.72 0 0 0-2.769.535 6.605 6.605 0 0 0-2.29 1.62 7.466 7.466 0 0 0-2.046 5.259 7.22 7.22 0 0 0 .533 2.872 7.33 7.33 0 0 0 1.632 2.442 7.309 7.309 0 0 0 2.48 1.635c.932.371 1.933.55 2.939.523h.068l-.03-.059a8.732 8.732 0 0 0 3.091-.561 6.491 6.491 0 0 0 2.379-1.509l.025-.025-1.46-1.856-.034.033c-.521.51-1.143.91-1.827 1.176a5.501 5.501 0 0 1-2.153.37 4.698 4.698 0 0 1-3.322-1.223 4.898 4.898 0 0 1-1.571-3.102h11.358v-.029c.074-.311.106-.631.094-.951a6.973 6.973 0 0 0-.506-2.743 7.089 7.089 0 0 0-1.544-2.34 6.739 6.739 0 0 0-2.3-1.559 6.848 6.848 0 0 0-2.747-.508Zm.09 2.343a4.093 4.093 0 0 1 2.844 1.048 4.839 4.839 0 0 1 1.447 2.933h-8.582a5.143 5.143 0 0 1 1.435-2.896 3.865 3.865 0 0 1 1.283-.845 3.932 3.932 0 0 1 1.518-.286v.03l.055.016Zm17.805-1.747a3.41 3.41 0 0 0-2.182-.625 4.094 4.094 0 0 0-2.055.53 4 4 0 0 0-1.497 1.482v-1.677h-2.746v14.153h2.763l-.06-8.151a4.54 4.54 0 0 1 .739-2.766c.227-.32.532-.58.887-.756a2.444 2.444 0 0 1 1.145-.254 3.255 3.255 0 0 1 1.862.549l.038.029 1.145-2.514h-.039Zm6.968-.596a6.724 6.724 0 0 0-2.77.535 6.616 6.616 0 0 0-2.29 1.62 7.465 7.465 0 0 0-2.045 5.259c-.021.983.159 1.96.531 2.873a7.313 7.313 0 0 0 1.634 2.44 7.293 7.293 0 0 0 2.479 1.636c.932.372 1.933.55 2.939.523h.068l-.03-.059a8.715 8.715 0 0 0 3.088-.561 6.51 6.51 0 0 0 2.382-1.509v-.025l-1.456-1.856-.034.033c-.521.51-1.143.91-1.827 1.176a5.501 5.501 0 0 1-2.153.37 4.71 4.71 0 0 1-3.326-1.223 4.914 4.914 0 0 1-1.567-3.101h11.358v-.03a3.71 3.71 0 0 0 .094-.951 7.024 7.024 0 0 0-.508-2.742 7.114 7.114 0 0 0-1.542-2.342 6.745 6.745 0 0 0-2.29-1.553 6.851 6.851 0 0 0-2.735-.513Zm.089 2.343a4.1 4.1 0 0 1 2.844 1.048 4.866 4.866 0 0 1 1.448 2.933h-8.583a5.145 5.145 0 0 1 1.448-2.87 3.876 3.876 0 0 1 1.283-.846 3.934 3.934 0 0 1 1.518-.286v.03l.042-.009Zm20.355.009a5.853 5.853 0 0 0-2.188-1.804 5.967 5.967 0 0 0-2.795-.577 6.627 6.627 0 0 0-2.737.525 6.518 6.518 0 0 0-2.263 1.6 8.05 8.05 0 0 0-1.986 5.306 8.054 8.054 0 0 0 2.016 5.296 6.567 6.567 0 0 0 2.251 1.591 6.69 6.69 0 0 0 2.719.538 5.972 5.972 0 0 0 2.809-.617 5.861 5.861 0 0 0 2.174-1.851v2.116h2.736V28.958h-2.749l.013 7.841Zm-1.281 1.563a4.948 4.948 0 0 1 1.281 3.47 5.058 5.058 0 0 1-1.307 3.495 4.127 4.127 0 0 1-1.478 1.083 4.21 4.21 0 0 1-1.81.346 4.342 4.342 0 0 1-1.823-.351 4.27 4.27 0 0 1-1.499-1.078 4.979 4.979 0 0 1-1.336-3.495 4.851 4.851 0 0 1 1.336-3.47 4.338 4.338 0 0 1 1.506-1.054 4.403 4.403 0 0 1 1.816-.342 4.343 4.343 0 0 1 1.803.342c.568.241 1.076.6 1.489 1.053h.022Zm10.346-3.592h-2.746v14.152h2.746V34.771Zm23.731 1.215a5.339 5.339 0 0 0-1.873-1.234 5.42 5.42 0 0 0-2.226-.362c-1.896 0-3.331.67-4.27 1.99v-7.45h-2.745v19.964h2.745l.06-8.21a3.87 3.87 0 0 1 .948-2.732c.328-.337.728-.6 1.17-.77.443-.17.917-.243 1.392-.215a3.491 3.491 0 0 1 2.604 1.014 3.728 3.728 0 0 1 .978 2.703v8.24H230v-8.65c0-1.81-.504-3.21-1.537-4.288ZM132.273 7.35c-1.943-1.676-4.479-2.514-7.549-2.514h-5.683l.026 18.134v.042h5.947c2.989 0 5.461-.838 7.344-2.515a8.472 8.472 0 0 0 2.154-2.975 8.353 8.353 0 0 0 .682-3.588 8.256 8.256 0 0 0-.706-3.614 8.395 8.395 0 0 0-2.215-2.97Zm.047 6.56c.036.9-.131 1.797-.487 2.628a6.157 6.157 0 0 1-1.575 2.178c-1.358 1.194-3.198 1.798-5.474 1.798h-2.989V7.304h2.989c2.276 0 4.116.608 5.474 1.803a6.145 6.145 0 0 1 1.575 2.176c.357.83.523 1.726.487 2.626Zm11.478-4.845a6.818 6.818 0 0 0-2.731.515 6.706 6.706 0 0 0-2.282 1.56 7.31 7.31 0 0 0-2.058 5.074 7.31 7.31 0 0 0 2.058 5.075 6.723 6.723 0 0 0 2.28 1.569c.864.36 1.794.54 2.733.527h.038v-.055a6.848 6.848 0 0 0 2.728-.53 6.732 6.732 0 0 0 2.276-1.565 7.286 7.286 0 0 0 2.054-5.06 7.286 7.286 0 0 0-2.054-5.061 6.744 6.744 0 0 0-2.3-1.548 6.858 6.858 0 0 0-2.742-.501Zm3.198 10.531a4.06 4.06 0 0 1-1.413 1.031 4.396 4.396 0 0 1-1.755.34 4.171 4.171 0 0 1-1.755-.335 4.093 4.093 0 0 1-1.443-1.036 4.79 4.79 0 0 1-1.281-3.352 4.658 4.658 0 0 1 1.281-3.353 4.156 4.156 0 0 1 1.449-1.016 4.23 4.23 0 0 1 1.749-.33 4.17 4.17 0 0 1 1.735.33 4.105 4.105 0 0 1 1.433 1.016 4.772 4.772 0 0 1 1.255 3.353 4.902 4.902 0 0 1-1.255 3.352Zm13.279.65c-.226.24-.503.426-.812.546-.309.12-.642.172-.973.15-1.251 0-1.862-.692-1.862-2.096v-7.124h3.89V9.408h-3.92V6.056h-2.6v3.352h-2.306l.09 2.284h2.272v7.2c0 1.433.375 2.556 1.105 3.353.731.796 1.708 1.14 3.058 1.14a4.568 4.568 0 0 0 1.775-.254 4.509 4.509 0 0 0 1.534-.916l.025-.02-1.229-1.966-.047.017Zm29.871-8.914a5.636 5.636 0 0 0-2.106-1.74 5.748 5.748 0 0 0-2.694-.557 6.389 6.389 0 0 0-2.634.509c-.83.353-1.573.88-2.178 1.54a7.74 7.74 0 0 0-1.913 5.108 7.744 7.744 0 0 0 1.943 5.097 6.337 6.337 0 0 0 2.166 1.53c.825.354 1.717.53 2.616.52a5.747 5.747 0 0 0 2.706-.596 5.638 5.638 0 0 0 2.094-1.785V23h2.643V9.38h-2.643v1.953Zm-1.256 1.5a4.773 4.773 0 0 1 1.256 3.353 4.914 4.914 0 0 1-1.256 3.353 4.06 4.06 0 0 1-1.413 1.03 4.403 4.403 0 0 1-1.755.34 4.166 4.166 0 0 1-1.756-.336 4.1 4.1 0 0 1-1.442-1.039 4.785 4.785 0 0 1-1.281-3.352 4.657 4.657 0 0 1 1.281-3.353 4.166 4.166 0 0 1 1.449-1.016 4.233 4.233 0 0 1 1.749-.33 4.18 4.18 0 0 1 1.735.334c.547.233 1.036.58 1.433 1.016Zm14.074 2.879a24.007 24.007 0 0 0-2.34-.708 6.949 6.949 0 0 1-1.977-.788 1.462 1.462 0 0 1-.568-.523 1.438 1.438 0 0 1-.218-.734l.052-.105c-.003-.242.057-.48.175-.692.118-.212.29-.39.499-.519a3.215 3.215 0 0 1 1.823-.473c1.533 0 2.682.502 3.51 1.537l.03.038 1.58-1.555v-.029c-1.021-1.395-2.754-2.095-5.162-2.095-1.529 0-2.759.373-3.655 1.115a3.36 3.36 0 0 0-1.007 1.184c-.237.466-.36.98-.36 1.502-.033.819.26 1.618.816 2.23a4.91 4.91 0 0 0 2.002 1.311c.854.306 1.58.553 2.281.767.681.19 1.328.484 1.917.872.24.137.439.334.578.571.139.237.211.505.212.778a1.718 1.718 0 0 1-.675 1.412 3.06 3.06 0 0 1-1.934.528c-1.785 0-3.19-.603-4.176-1.793l-.03-.038-1.55 1.701v.026c1.208 1.475 3.083 2.22 5.551 2.22 1.738 0 3.048-.372 4.001-1.14.455-.344.821-.79 1.069-1.299.248-.51.37-1.07.357-1.634a3.25 3.25 0 0 0-.816-2.317 4.948 4.948 0 0 0-1.985-1.35Zm11.665-6.705c-1.823 0-3.203.645-4.108 1.92v-7.49h-2.647V22.97h2.643l.06-7.9c-.048-.96.279-1.9.914-2.632a3.15 3.15 0 0 1 1.131-.742 3.212 3.212 0 0 1 1.345-.205 3.35 3.35 0 0 1 1.36.225 3.28 3.28 0 0 1 1.146.752c.651.712.988 1.647.94 2.602V23h2.643v-8.328c0-1.74-.487-3.089-1.482-4.124a5.133 5.133 0 0 0-1.802-1.191 5.21 5.21 0 0 0-2.143-.351Zm-40.99 2.326a5.629 5.629 0 0 0-2.106-1.74 5.744 5.744 0 0 0-2.693-.557 6.399 6.399 0 0 0-2.635.51 6.264 6.264 0 0 0-2.177 1.54 7.741 7.741 0 0 0-1.914 5.107 7.744 7.744 0 0 0 1.943 5.097 6.34 6.34 0 0 0 2.167 1.53c.824.354 1.716.53 2.616.52a5.746 5.746 0 0 0 2.705-.596 5.63 5.63 0 0 0 2.094-1.785V23h2.643V3.466h-2.643v7.866Zm-1.255 1.5a4.772 4.772 0 0 1 1.255 3.353 4.913 4.913 0 0 1-1.255 3.353c-.39.446-.877.801-1.426 1.038a4.064 4.064 0 0 1-1.743.332 4.155 4.155 0 0 1-1.755-.336 4.093 4.093 0 0 1-1.443-1.039 4.79 4.79 0 0 1-1.281-3.352 4.661 4.661 0 0 1 1.281-3.353 4.166 4.166 0 0 1 1.449-1.016 4.232 4.232 0 0 1 1.749-.33 4.181 4.181 0 0 1 1.74.332c.549.233 1.039.58 1.437 1.018h-.008Z" fill="#000"></path>
      </svg>
    </a> -->

      <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div id="navbarBasicExample" class="navbar-menu">
      <div class="navbar-start">
        <router-link class="navbar-item" to="/"><span class="icon"><i class="fas fa-home"></i></span>&nbsp;Home</router-link>
        <a class="navbar-item" href="https://dotdash.atlassian.net/servicedesk/customer/portal/37/article/7531003973" target="_blank" rel="noopener noreferrer"> Help </a>
        <router-link class="navbar-item" to="/about">About</router-link>
        <a class="navbar-item" href="https://jira.meredith.com/servicedesk/customer/portal/181/create/421" target="_blank"> Report an issue </a>

<!--        <div class="navbar-item has-dropdown is-hoverable" >-->
<!--          <a class="navbar-link"> More </a>-->
<!--          <div class="navbar-dropdown">-->
<!--            <router-link class="navbar-item" to="/"><span class="icon"><i class="fas fa-home"></i></span>&nbsp;Home</router-link>-->
<!--            <router-link class="navbar-item" to="/about">About</router-link>-->
<!--            <hr class="navbar-divider">-->
<!--            <router-link class="navbar-item" to="/documentation"> Documentation </router-link>-->
<!--            <a class="navbar-item" href="https://jira.meredith.com/servicedesk/customer/portal/181/create/421" target="_blank"> Report an issue </a>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="navbar-end">
        <div class="navbar-item">
          <form class="navbar-search-form" @submit.prevent="serachRedirect">
            <div class="control has-icons-left">
              <input class="input is-small" type="text" placeholder="search" v-model="searchStr">
              <button type="submit" class="icon is-small is-left navbar-search-submit" aria-label="Search">
                <i class="fas fa-search" aria-hidden="true"></i>
              </button>
            </div>
          </form>
          <div class="buttons" v-show="false">
            <a class="button is-light">
              Login
            </a>
          </div>
          <button type="button" class="button is-white" v-on:click="isShowModal = true">Advanced Search</button>
          <button type="button" class="button is-white" v-if="!authState?.isAuthenticated" v-on:click="login()">Login</button>
          <button type="button" class="button is-white" v-if="authState?.isAuthenticated" v-on:click="logout()">Logout</button>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal" id="modal-lg" size="lg" v-bind:class="{ 'is-active': isShowModal }">
      <div class="modal-background" v-on:click="isShowModal = false"></div>
      <div class="modal-card ">
        <header class="modal-card-head headerwidth">
          <p class="modal-card-title">
            <button type="button" v-on:click="addNewData" class="button is-light"><i style="font-size:20px;color:#42B983;" class="fa">&#xf0fe;</i>&nbsp;Add Criteria</button>
          </p>
          <button class="delete" aria-label="close" v-on:click="isShowModal = false"></button>
        </header>
        <div class="modal-card-body modalheight">
          <form role="form" id="advSearchform" @submit="getSearch">
            <div v-for="(data, index) in advance_search_data" :key="index">
              <select v-model="data.selectOption" id="mySelect" @change="getSearchType(data.selectOption, index),refreshOnChangePage(index)" class="select is-medium-type" required>
                <option disabled selected value="">Select Criteria</option>
                <option v-for="(criteria, ind) in data.arrCriteria" :key="ind" :value="criteria[0]">{{criteria[0]}}</option>
              </select>&nbsp;
              <i v-if="data.selectOption === 'Publications' "  >
                <div class="multiselect is-medium" v-on:keyup.enter="showSearch">
                  <div class="selectBox" v-on:click="showCheckboxes">
                    <select v-model="whitelisted_brands_dict" class="select is-medium-pub" style="font-style: normal;">
                    </select>
                    <div class="overSelect" v-if="checkboxselected.length === 0" style="font-style: normal;">Select publication(s) from list</div>
                    <div class="overSelect" v-else style="font-style: normal;">{{checkboxselected.toString()}}</div>
                  </div>
                  <div id="checkboxes" style="font-size: smaller; width: 60%; position: absolute; z-index:999; background-color: #FFFFFF; height: 75px; overflow: auto;">
                    <div v-for="(key, value) in whitelisted_brands_dict" v-bind:key="key" style="font-style: normal;">
                      <label :for=key>
                        &nbsp;<input type="checkbox" :id="key" v-on:click="getCheckboxclick(value)" style="font-style: normal;"/>&nbsp;{{value}}</label>
                    </div>
                  </div>
                </div>
              </i>
              <i v-else-if="data.selectOption === 'Date Is' || data.selectOption === 'Date After' || data.selectOption === 'Date Before' ">
                <input v-model="data.value" type="date" class="input is-medium" style="margin-bottom:15px; font-size: 1rem; height: 35px; width:65%" v-on:keyup.enter="triggerSearch" required>&nbsp;
              </i>
              <i v-else>
                <input v-model="data.value" class="select is-medium" size="39" style="margin-bottom: 15px;font-size: 1rem;" v-on:keyup.enter="triggerSearch" required>&nbsp;
              </i>
              <i class="btn btn-danger" style="float:right;" v-on:click="popThisData(index)">
                <i class="fa fa-minus-circle" style="color:red;"></i>
              </i>
            </div>
            <footer class="modal-card-foot footerwidth">
              <button type="submit" class="button is-success" style="background-color: #42B983;">Search</button>
              &nbsp;<button type="button" class="button" v-on:click="isShowModal = false">Cancel</button>
            </footer>
          </form>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
export default {
  name: 'NavBar',
  data () {
    return {
      searchStr: '',
      isShowModal: false,
      advance_search_data: [ {
        selectOption: '',
        message: '',
        arrCriteria: [ ['Search', '1'], ['Publications', '2'], ['Date Before', '3'], ['Date Is', '4'], ['Date After', '5'], ['Headline', '6'], ['Deck/Lead', '7'], ['Byline', '8'], ['Caption', '9'], ['Section', '9'] ]
      }],
      expanded: false,
      checkboxselected: [],
      searchParamVal: '',
      searchType: [],
      advancedSearchKeyword: '',
      typeSelected: '',
      whitelisted_brands_dict: {
        'All recipes': 'ALLRECIPES',
        'All you': 'ALLYOU',
        'Better Homes & Gardens': 'BHG',
        'Business 2.0': 'BUSINESS',
        'Coastal living': 'COASTALLIVING',
        'Cooking light': 'COOKINGLIGHT',
        'Country Gardens': 'COUNTRYGARDENS',
        'Diabetic living': 'DIABETICLIVING',
        'Do it yourself': 'DOITYOURSELF',
        'Eating well': 'EATINGWELL',
        'Entertainment weekly': 'ENTERTAINMENTWEEKLY',
        'Family circle': 'FAMILYCIRCLE',
        'Fine Cooking': 'FINECOOKING',
        'Food and wine': 'FOODANDWINE',
        'Health': 'HEALTHCOM',
        'Homes and Gardens': 'HOMESANDGARDENS',
        'Instyle': 'INSTYLE',
        'Life': 'LIFE',
        'Martha Stewart Living': 'MARTHASTEWART',
        'Midwest living': 'MIDWESTLIVING',
        'Millie': 'MILLIE',
        'Parents': 'PARENTS',
        'Parents Latina': 'PARENTSLATINA',
        'People': 'PEOPLE',
        'People stylewatch': 'PEOPLESTYLEWATCH',
        'People Enespanol': 'PEOPLEENESPANOL',
        'Rachael ray': 'RACHAELRAYMAG',
        'Realsimple': 'REALSIMPLE',
        'Reveal': 'REVEAL',
        'Shape': 'SHAPE',
        'Southern living': 'SOUTHERNLIVING',
        'Successful Farming': 'SUCCESSFULFARMING',
        'Magnolia Journal': 'MAGNOLIAJOURNAL',
        'Traditional home': 'TRADITIONALHOME',
        'Travel + Leisure': 'TRAVELANDLEISURE',
        'Wood': 'WOODMAGAZINE'
      }
    }
  },
  methods: {
    login () {
      this.$auth.signInWithRedirect({ originalUri: '/' })
    },
    async logout () {
      await this.$auth.signOut()
    },
    getSearch: function (e) {
      // console.log(e.id)
      e.preventDefault()
      this.showSearch()
    },
    serachRedirect: function () {
      const q = (this.searchStr || '').trim()
      const dest = { name: 'search', query: { q } }
      if (this.$route.name === 'search' && String(this.$route.query.q || '') === q) {
        return
      }
      this.$router.push(dest).catch(() => {})
    },
    resetAdvancedSearch: function () {
      this.isShowModal = false
      this.advance_search_data = [{
        selectOption: '',
        message: '',
        arrCriteria: [ ['Search', '1'], ['Publications', '2'], ['Date Before', '3'], ['Date Is', '4'], ['Date After', '5'], ['Headline', '6'], ['Deck/Lead', '7'], ['Byline', '8'], ['Caption', '9'], ['Section', '9'] ]
      }]
      this.expanded = false
      this.checkboxselected = []
      this.searchParamVal = ''
      this.searchType = []
      this.advancedSearchKeyword = ''
      this.typeSelected = ''
      try {
        const checkboxes = document.getElementById('checkboxes')
        if (checkboxes) {
          checkboxes.style.display = 'none'
        }
      } catch (e) {
        console.log('')
      }
    },
    addNewData: function () {
      let isPublicationSelected = false; let isDateBeforeSelected = false; let isDateAfterSelected = false; let isDateIsSelected = false
      for (let i = 0; i < this.advance_search_data.length; i++) {
        let checkvalue = this.advance_search_data[i].selectOption
        if (checkvalue === 'Publications') {
          isPublicationSelected = true
        }
        if (checkvalue === 'Date Before') {
          isDateBeforeSelected = true
        }
        if (checkvalue === 'Date After') {
          isDateAfterSelected = true
        }
        if (checkvalue === 'Date Is') {
          isDateIsSelected = true
        }
      }
      let arrCriteria1 = [['Search', '1'], ['Headline', '6'], ['Deck/Lead', '7'], ['Byline', '8'], ['Caption', '9'], ['Section', '9']]
      if (!isPublicationSelected) {
        arrCriteria1.push(['Publications', '2'])
      }

      if (!isDateBeforeSelected) {
        arrCriteria1.push(['Date Before', '3'])
      }

      if (!isDateAfterSelected) {
        arrCriteria1.push(['Date After', '5'])
      }

      if (!isDateIsSelected) {
        arrCriteria1.push(['Date Is', '4'])
      }
      function Comparator (a, b) {
        if (a[1] < b[1]) return -1
        if (a[1] > b[1]) return 1
        return 0
      }
      arrCriteria1.sort(Comparator)
      this.advance_search_data.push({
        selectOption: '',
        message: '',
        arrCriteria: arrCriteria1
      })
      try {
        if (document.getElementById('checkboxes').style.display !== 'none') {
          document.getElementById('checkboxes').style.display = 'none'
        }
      } catch (e) {
        console.log('')
      }
    },
    refreshOnChangePage: function (index) {
      this.count = []
      // console.log(index)
      for (let j = 0; j < this.advance_search_data.length; j++) {
        if (this.advance_search_data[j].selectOption === '') {
          this.count.push(j)
        }
      }
      if (this.count.length !== 0) {
        let x = 0
        while (this.count.length > x) {
          this.advance_search_data.splice(this.count[x] - x, 1)
          this.addNewData()
          x++
        }
      }
    },
    refreshPage: function (index) {
      this.count = []
      // console.log(index)
      for (let j = 0; j < this.advance_search_data.length; j++) {
        if (this.advance_search_data[j].selectOption === '') {
          this.count.push(j)
        }
      }
      if (this.count.length !== 0) {
        for (let x = 0; x < this.count.length; x++) {
          try {
            this.advance_search_data.pop({
              selectOption: '',
              message: '',
              arrCriteria: ''
            })
          } catch (err) {
            console.log('')
          }
        }
        for (let x = 0; x < this.count.length; x++) {
          try {
            this.addNewData()
          } catch (err) {
            console.log('')
          }
        }
      }
    },
    popThisData: function (index) {
      let removeCriteria = this.advance_search_data.splice(index, 1)
      this.searchType.splice(this.searchType.indexOf(removeCriteria[0].selectOption), 1)
      if (removeCriteria[0].selectOption === 'Publications') {
        this.checkboxselected = []
      }
      this.refreshPage(index)
    },
    showCheckboxes: function () {
      var checkboxes = document.getElementById('checkboxes')
      if (!this.expanded) {
        checkboxes.style.display = 'block'
        this.expanded = true
      } else {
        checkboxes.style.display = 'none'
        this.expanded = false
      }
    },
    hideCheckboxes: function () {
      var checkboxes = document.getElementById('checkboxes')
      checkboxes.style.display = 'none'
      this.expanded = false
    },
    getCheckboxclick: function (value) {
      if (this.checkboxselected.includes(value)) {
        this.checkboxselected.splice(this.checkboxselected.indexOf(value), 1)
      } else {
        this.checkboxselected.push(value)
      }
    },
    getSearchType: function (value, index) {
      this.searchType[index] = value
    },
    showSearch: function (value) {
      this.searchParamVal = ''
      this.advancedSearchKeyword = ''
      this.typeSelected = ''
      // console.log(this.advance_search_data)
      for (let i = 0; i < this.searchType.length; i++) {
        if (this.searchType[i] === 'Publications') {
          if (this.$store.state.activeBrandName !== '') {
            if (!this.checkboxselected.includes(this.$store.state.activeBrandName)) { this.checkboxselected.push(this.$store.state.activeBrandName) }
          }
          for (let i = 0; i < this.checkboxselected.length; i++) {
            if (i < this.checkboxselected.length - 1) {
              this.searchParamVal += this.whitelisted_brands_dict[this.checkboxselected[i]] + ','
            } else {
              this.searchParamVal += this.whitelisted_brands_dict[this.checkboxselected[i]]
            }
          }
          this.typeSelected += this.advance_search_data[i].selectOption
        } else if (this.searchType[i] === 'Search') {
          this.advancedSearchKeyword += this.advance_search_data[i].value + ' '
        } else if (this.searchType[i] === 'Byline') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += this.advance_search_data[i].selectOption
        } else if (this.searchType[i] === 'Deck/Lead') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'DeckLead'
        } else if (this.searchType[i] === 'Headline') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'Headline'
        } else if (this.searchType[i] === 'Caption') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'Caption'
        } else if (this.searchType[i] === 'Section') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += 'Section'
        } else if (this.searchType[i] === 'Date Is' || this.searchType[i] === 'Date Before' || this.searchType[i] === 'Date After') {
          this.searchParamVal += this.advance_search_data[i].value
          this.typeSelected += this.advance_search_data[i].selectOption.replace(' ', '')
        }
        if (this.searchType[i].length > 1 && this.searchType[i] !== 'Search') {
          this.typeSelected += '%7C'
          this.searchParamVal += '%7C'
        }
      }
      this.typeSelected = this.typeSelected.slice(0, -3)
      this.searchParamVal = this.searchParamVal.slice(0, -3)
      this.advancedSearchKeyword = this.advancedSearchKeyword.trim()

      if (this.$store.state.activeBrandName !== '' && !this.searchType.includes('Publications')) {
        this.typeSelected += '%7CPublications'
        this.searchParamVal += '%7C' + this.whitelisted_brands_dict[this.$store.state.activeBrandName]
      }
      this.isShowModal = false
      this.searchStr = ''
      if (this.advancedSearchKeyword === '' && this.typeSelected === '' && this.searchParamVal === '') {
        this.isShowModal = true
        alert('Please select any criteria!')
        return false
      }
      if (this.typeSelected === 'Publications' && this.searchParamVal === '') {
        this.isShowModal = true
        alert('Please select any publication!')
        return false
      }
      this.$router.push({ name: 'search', query: { q: this.advancedSearchKeyword !== '' ? this.advancedSearchKeyword : '', type: this.typeSelected !== '' ? this.typeSelected : '0', val: this.searchParamVal !== '' ? this.searchParamVal : '0' } })
    }
  },
  computed: {
    message: function () {
      return ''
    }
  },
  watch: {
    '$route.name' (name) {
      if (name !== 'search') {
        this.searchStr = ''
        this.resetAdvancedSearch()
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .navbar-search-form {
    display: inline-block;
    margin: 0;
  }
  .navbar-search-submit {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    pointer-events: auto;
  }
  .navbar-menu a.router-link-exact-active {
    color: #42b983;
  }
  /* .navbar-item img {
    max-height: 2.65rem;
  }  */
  .multiselect {
    width: 300px;
    display: table-cell;
  }
  .select {
    display: inline-block;
  }
  .select.is-medium-type {
    font-size: 1rem;
    width: 30%;
  }
  .select.is-medium {
    font-size: 1rem;
    width: 65%;
  }
  .select is-medium-pub {
    font-size: 1rem;
    width: 150%;
    height: 45px;
  }
  .selectBox {
    position: relative;
    width: 100%;
    height: 100%;
    margin-bottom: 15px;
  }
  .selectBox select {
    width: 390px;
    height: 35px;
    font-weight: bold;
  }
  .overSelect {
    position: absolute;
    left: 5px;
    right: 0;
    top: 10px;
    bottom: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  #checkboxes {
    display: none;
    border: 1px #a5a5a5 solid;
    margin-top: -15px;
    margin-left: 1px;
  }
  #checkboxes label {
    display: block;
  }
  #checkboxes label:hover {
    background-color: #1e90ff;
  }
  .modalheight {
    margin-bottom: -20px;
  }
  .footerwidth {
    width: 107%;
    height: 60px;
    margin-left: -18px;
  }
  .headerwidth {
    width: 104%;
    height: 60px;
    margin-left: -18px;
  }
</style>
